import { render } from "./UserList.vue?vue&type=template&id=82fcd098&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=82fcd098&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82fcd098"]])

export default __exports__